import { isServer } from '@/utils/runtime'

export const saveSource = (source: string) => {
  if (typeof window === 'undefined') return

  sessionStorage.setItem('source', source)
}

export const getSource = () => {
  if (isServer) return null

  const source = sessionStorage.getItem('source')

  sessionStorage.removeItem('source')

  return source
}
